/* eslint-disable @typescript-eslint/naming-convention */

import BodyTypeFilter from './Components/BodyTypeFilter/BodyTypeFilter';
import { ColorFilter } from './Components/ColorFilter/ColorFilter';
import { DoorsFilter } from './Components/DoorsFilter/DoorsFilter';
import { EngineSizeFilter } from './Components/EngineSizeFilter/EngineSizeFilter';
import { FuelFilter } from './Components/FuelFilter/FuelFilter';
import { GearboxFilter } from './Components/GearboxFilter/GearboxFilter';
import { IncludeSold } from './Components/IncludeSold/IncludeSold';
import { LocationFilterUk } from './Components/LocationFilter/LocationFilterUk';
import MakeFilter from './Components/MakeFilter/MakeFilter';
import { MileageFilter } from './Components/MileageFilter/MileageFilter';
import ModelFilter from './Components/ModelFilter/ModelFilter';
import ModelVariantFilter from './Components/ModelVariantFilter/ModelVariantFilter';
import { PowerFilter } from './Components/PowerFilter/PowerFilter';
import { PriceFilter } from './Components/PriceFilter/PriceFilter';
import { SeatsFilter } from './Components/SeatsFilter/SeatsFilter';
import { ShowOnly } from './Components/ShowOnly/ShowOnly';
import { getEnabledToggleConfig } from './Components/ShowOnly/ShowOnly.utils';
import { YearFilter } from './Components/YearFilter/YearFilter';
import type { FilterCategories, FilterControlBaseProps } from './FilterPanel.entity';

const FILTER_CATEGORIES: FilterCategories = [
  {
    id: 'location',
    isMainFilter: true,
    defaultOpen: true,
    Component: ({ ...args }: FilterControlBaseProps) => <LocationFilterUk {...args} />,
  },
  {
    id: 'price',
    isMainFilter: true,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <PriceFilter {...args} />,
  },
  {
    id: 'make',
    isMainFilter: true,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <MakeFilter {...args} />,
  },
  {
    id: 'model',
    isMainFilter: true,
    parentId: 'make',
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <ModelFilter {...args} />,
  },
  {
    id: 'variant-type',
    isMainFilter: true,
    parentId: 'model',
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <ModelVariantFilter {...args} />,
  },
  {
    id: 'fuelType',
    isMainFilter: true,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <FuelFilter {...args} />,
  },
  {
    id: 'year',
    isMainFilter: true,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <YearFilter {...args} />,
  },
  {
    id: 'mileage',
    isMainFilter: true,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <MileageFilter {...args} />,
  },
  {
    id: 'gearBox',
    isMainFilter: false,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <GearboxFilter {...args} />,
  },
  {
    id: 'color',
    isMainFilter: false,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <ColorFilter {...args} />,
  },
  {
    id: 'doors',
    isMainFilter: false,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <DoorsFilter {...args} />,
  },
  {
    id: 'seats',
    isMainFilter: false,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <SeatsFilter {...args} />,
  },
  {
    id: 'bodyType',
    isMainFilter: false,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <BodyTypeFilter {...args} />,
  },
  {
    id: 'engineSize',
    isMainFilter: false,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <EngineSizeFilter {...args} />,
  },
  {
    id: 'enginePower',
    isMainFilter: false,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <PowerFilter {...args} />,
  },
  {
    id: 'showOnly',
    isMainFilter: false,
    defaultOpen: true,
    Component: ({ ...args }: FilterControlBaseProps) => <ShowOnly {...args} />,
    getIsHidden: props => {
      const toggleConfig = getEnabledToggleConfig(props);
      const hasActiveToggles = Object.keys(toggleConfig).some(
        toggleKey => toggleConfig[toggleKey as keyof typeof toggleConfig],
      );
      return !hasActiveToggles;
    },
  },
  {
    id: 'includeSold',
    label: 'Hide Sold',
    isMainFilter: false,
    defaultOpen: false,
    Component: ({ ...args }: FilterControlBaseProps) => <IncludeSold {...args} />,
  },
];

export { FILTER_CATEGORIES };
